var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-items main__light_green h5-headline text-start black--text",class:_vm.customClass || ' py-16 px-12 mt-4 ',attrs:{"data-qa":"empty-block"}},[_c('span',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.text),expression:"text"}],attrs:{"data-qa":"empty-block-text"}}),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }